// Utils
import { isBoardLike } from '../../../../common/elements/utils/elementTypeUtils';

export default ({ monitor }) => {
    const item = monitor.getItem();
    return item.draggedElements && item.draggedElements.every(isBoardLike);
};
